import { Injectable } from '@angular/core';

import { AuthService } from '@app/api/api-services/auth.service';
import { RouteHelperService } from '../route-helper.service';

@Injectable()
export class AuthGuard {
  constructor(private readonly authService: AuthService, private readonly routeHelper: RouteHelperService) {}

  public canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    this.routeHelper.login(true);

    return false;
  }

  public canActivateChild(): boolean {
    return this.canActivate();
  }
}
